import React, { Component } from 'react';

import { LOOM_URI } from 'constants/routes';

import './styles.less';

class GmailDropdownItem extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  render() {
    const { video } = this.props;

    const videoUrl = `${LOOM_URI}/share/${video.id}`;

    const gmailURL =
      'https://mail.google.com/mail/?view=cm&fs=1&' +
      [
        `su=${window.encodeURIComponent(`${video.name} [video]`)}`,
        `body=${window.encodeURIComponent(videoUrl)}`,
      ].join('&');

    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={gmailURL}
        onClick={this.onClick}
      >
        <li className="share-video-gmail-dropdown-item">
          <div className="icon" />
          <span>Gmail</span>
        </li>
      </a>
    );
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }
}

export default GmailDropdownItem;
